import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Modal, Button, Input, Card, Row, Col, Tooltip, message } from "antd";
import {
    FacebookFilled,
    InstagramFilled,
    TwitterSquareFilled,
    LinkedinFilled,
    YoutubeFilled,
} from "@ant-design/icons";
import styles from "./style/SocialMedia.module.css"; // Import CSS module
import { useCurrentUser } from "../actions/auth";

export default function SocialMediaModal({ trigger }) {
    const { isLoading, isSuccess, data: dataMe } = useCurrentUser();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const [open, setOpen] = useState(false);
    const [links, setLinks] = useState({});
    const [loading, setLoading] = useState(false);
    const status = searchParams.get("status");
    const msg = searchParams.get("msg");

    const selected_org = dataMe?.selected_org?.id;
    const user_id = dataMe?.id;
    const stateObj = {
        user_id: user_id,
        org_id: selected_org,
        return_url: window.location.href,
    };
    const stateStr = JSON.stringify(stateObj);
    const encodedState = encodeURIComponent(stateStr);
    const socialPlatforms = [
        {
            name: "Facebook",
            icon: "/images_rte/icons/facebook.png",
            placeholder: "Facebook Profile URL",
            key: "facebook",
        },
        {
            name: "Instagram",
            icon: "/images_rte/icons/instagram.png",
            placeholder: "Instagram Username",
            key: "instagram",
            link: `https://www.instagram.com/oauth/authorize?force_reauth=false&client_id=1430244024776272&redirect_uri=https://botapi.qureal.com/social/instagram/callback&response_type=code&scope=instagram_business_basic,instagram_business_content_publish`,
        },
        {
            name: "Twitter",
            icon: "/images_rte/icons/twitter.png",
            placeholder: "Twitter Handle",
            key: "twitter",
        },
        {
            name: "YouTube",
            icon: "/images_rte/icons/youtube.png",
            placeholder: "YouTube Channel URL",
            key: "youtube",
        },

        {
            name: "LinkedIn",
            icon: "/images_rte/icons/linkedin.png",
            placeholder: "LinkedIn Profile URL",
            key: "linkedin",
            link: `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77c99lfcwqw0ih&redirect_uri=https://botapi.qureal.com/social/linkedin/callback&scope=openid%20profile%20email%20w_member_social&state=${encodedState}`,
        },
        {
            name: "Medium",
            icon: "/images_rte/icons/medium.png",
            placeholder: "YouTube Channel URL",
            key: "medium",
        },
        {
            name: "Pinterest",
            icon: "/images_rte/icons/pinterest.png",
            placeholder: "YouTube Channel URL",
            key: "pinterest",
        },
        {
            name: "Threads",
            icon: "/images_rte/icons/threads.png",
            placeholder: "YouTube Channel URL",
            key: "threads",
        },
    ];

    // Utility to extract platform key from msg
    const getPlatformKeyFromMsg = (msg) => {
        if (!msg) return null;
        // Example: "LinkedIn connected successfully"
        const lowerMsg = msg.toLowerCase();
        const found = socialPlatforms.find((p) =>
            lowerMsg.includes(p.name.toLowerCase())
        );
        return found ? found.key : null;
    };

    useEffect(() => {
        if (status === "success" && msg) {
            message.success(msg);
            const platformKey = getPlatformKeyFromMsg(msg);
            if (platformKey) {
                setLinks((prev) => ({
                    ...prev,
                    [platformKey]: true, // or store the actual link if you have it
                }));
            }
        } else if (status === "error" && msg) {
            message.error(msg);
        }
        // eslint-disable-next-line
    }, [status, msg]);

    const handleInputChange = (key, value) => {
        setLinks((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setOpen(false);
            // Here you can handle the save logic (API call, etc.)
        }, 1200);
    };

    const handleLink = (platform) => {
        const url = platform.link;
        if (url) {
            window.location.href = url.startsWith("http")
                ? url
                : `https://${url}`;
        }
    };

    const handleUnlink = (key) => {
        setLinks((prev) => {
            const updated = { ...prev };
            delete updated[key];
            return updated;
        });
    };

    return (
        <>
            <div onClick={() => setOpen(true)}>{trigger}</div>
            <Modal
                open={open}
                style={{ top: 20 }}
                onCancel={() => setOpen(false)}
                width={800}
                title={
                    <>
                        <div className={styles.modalTitle}>
                            Add Your Social accounts
                        </div>
                        <span className={styles.subText}>
                            Connect your Facebook, Instagram, Twitter, Linkedin
                            and so on...
                        </span>
                    </>
                }
                footer={[
                    <Button key="cancel" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="save"
                        type="primary"
                        loading={loading}
                        onClick={handleSave}
                    >
                        Save
                    </Button>,
                ]}
            >
                <Row gutter={[16, 16]}>
                    {socialPlatforms.map((platform) => (
                        <Col xs={24} sm={12} md={8} lg={6} key={platform.key}>
                            <Card
                                bordered
                                className={styles.socialCard}
                                onClick={() => handleLink(platform)}
                            >
                                <Tooltip title={platform.name}>
                                    <img
                                        src={platform.icon}
                                        alt={platform.name}
                                        className={styles.socialImg}
                                    />
                                </Tooltip>
                                <div className={styles.platformName}>
                                    {platform.name}
                                </div>
                                {links[platform.key] && (
                                    <Button
                                        size="small"
                                        danger
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUnlink(platform.key);
                                        }}
                                        style={{ marginTop: 8 }}
                                    >
                                        Unlink
                                    </Button>
                                )}
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Modal>
        </>
    );
}
